'use client';

import { css } from '@linaria/core';

export const root = css`
  display: flex;
  min-height: 100dvh;
  min-width: 100dvw;
  justify-content: center;
  align-items: center;
`;
